import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "../views/HomePage/index.vue";
import SRM from "../views/SRM/index.vue";
import CRM from "../views/CRM/index.vue";

// 1. 使用插件
Vue.use(VueRouter);

// 2. 定义路由
const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/SRM",
    name: "SRM",
    component: SRM,
  },
  // 捕获所有 /SRM/* 及其深层子路由，重定向到 /SRM
  {
    path: "/SRM/*",
    redirect: "/SRM",
  },
  {
    path: "/CRM",
    name: "CRM",
    component: CRM,
  },
  // 捕获所有 /CRM/* 及其深层子路由，重定向到 /CRM
  {
    path: "/CRM/*",
    redirect: "/CRM",
  },
];

// 3. 创建路由实例
const router = new VueRouter({
  mode: "hash", // 可选：'hash'（默认）或 'history'
  base: process.env.BASE_URL,
  routes,
});

export default router;
